import { render, staticRenderFns } from "./officialHolidaysView.vue?vue&type=template&id=6d42f9d0&scoped=true&"
import script from "./officialHolidaysView.vue?vue&type=script&lang=js&"
export * from "./officialHolidaysView.vue?vue&type=script&lang=js&"
import style0 from "./officialHolidaysView.vue?vue&type=style&index=0&id=6d42f9d0&prod&lang=scss&scoped=true&"
import style1 from "./officialHolidaysView.vue?vue&type=style&index=1&id=6d42f9d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42f9d0",
  null
  
)

export default component.exports